<template>
  <div class="the-toasts">
    <transition-group
      name="fade"
      appear
    >
      <div
        v-for="item in items"
        :key="item.index"
        class="toasts-items"
      >
        <div class="card md-12">
          <div
            class="card-body"
            :class="{
              'success': item.type === 'success',
              'error': item.type === 'error',
            }"
          >
            <h5 class="card-title">
              {{ item.title }}
            </h5>
            <p class="card-text">
              {{ item.message }}
            </p>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    toastStack: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    items() {
      if (!this.toastStack.length) return []
      return [].concat(this.toastStack).map((obj) => {
        if (!obj.countDown) this.countDownToastsTime(obj.index)
        return obj
      }).reverse()
    }
  },
  methods: {
    ...mapActions([
      'countDownToastsTime'
    ])
  }
}
</script>
<style lang="scss" scoped>
</style>
